import { TailSpin } from 'react-loader-spinner';
import React from 'react';

const PageLoader = () => {
  return (
    <div style={styles.overlay}>
      <TailSpin height={80} width={80} color="#ffffff" />
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.5)', // fondo oscuro semi-transparente
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999, // por encima de todo
  },
};

export default PageLoader;
